import { render, staticRenderFns } from "./SpecialtiesComponent.vue?vue&type=template&id=4e1294e9&scoped=true"
import script from "./SpecialtiesComponent.vue?vue&type=script&lang=js"
export * from "./SpecialtiesComponent.vue?vue&type=script&lang=js"
import style0 from "./SpecialtiesComponent.vue?vue&type=style&index=0&id=4e1294e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1294e9",
  null
  
)

export default component.exports